import { listProductAccess, resolveProductAccess } from '@deque/billing-utils';
import type { ProductSlugs } from '~/common/constants';
import { useAuthContext } from '~/common/contexts/auth';
import { useEnterprises } from '~/common/contexts/enterprises';
import {
  getVisibleSubscriptions,
  hasAccessToProduct,
  hasAnyActiveSubscription
} from '~/common/utils/subscriptions';

export interface ConfigurationAccessState {
  userHasAccessToConfiguration: boolean;
  checkUserAccessToProduct: (slug: ProductSlugs) => boolean;
}
export const useConfigurationAccess = (): ConfigurationAccessState => {
  const { activeEnterprise, isAdmin: isEnterpriseAdmin } = useEnterprises();
  const { billingUser } = useAuthContext();

  const productAccess = !billingUser
    ? listProductAccess([])
    : activeEnterprise && isEnterpriseAdmin
      ? listProductAccess(
          getVisibleSubscriptions(billingUser, activeEnterprise)
        )
      : resolveProductAccess(billingUser, 'active');

  const userHasAccessToConfiguration = hasAnyActiveSubscription({
    productAccess
  });

  const checkUserAccessToProduct = (slug: ProductSlugs) =>
    hasAccessToProduct({ productAccess, slug });

  return { checkUserAccessToProduct, userHasAccessToConfiguration };
};
